<template>
  <div style="margin-top: 30px;">
    <draggable
      :disabled="moveDisabled"
      class="list-group"
      v-model="contents"
      v-bind="dragOptions"
      group="content"
      draggable=".list-group-item"
      @start="dragging = true"
      @end="handleEndDragging"
      @change="handleChangeSort"
    >
      <transition-group type="transition" :name="!dragging ? 'flip-list' : null">
        <form-content-item
          class="list-group-item"
          v-for="(content, index) in contents"
          :key="`content${index}`"
          :content="content"
          :onMoveDisabled="handleMoveDisabled"
          :isMoveContent="isMoveContent"
          :scrollPosition="scrollPosition"
        />
       </transition-group>
    </draggable>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import draggable from 'vuedraggable'
  import constants from '@/constants'
  import FormContentItem from './FormContentItem'
  import api from '@/services/api'
  import utils from '@/services/utils.js'
  export default {
    name: 'contents',
    components: {
      draggable,
      FormContentItem
    },
    props: {
      scrollPosition: {
        type: String,
        required: false,
        default: null
      }
      // contents: {
      //   type: Array,
      //   required: true
      // }
    },
    data: () => ({
      dragging: false,
      moveDisabled: true,
      isMoveContent: false
    }),
    computed: {
      ...mapState('app',['collapseContent', 'contents']),
      enterpriseID () {
        return this.$store.state.app.enterpriseID 
      },
      contents: {
        get() {
            return this.$store.state.app.contents
        },
        set(value) {
          this.handleMoveDisabled(true)
          this.$store.state.app.contents = value
          // this.$store.commit('updateList', value)
        }
      },
      dragOptions() {
        return {
          animation: 0,
          group: "content",
          disabled: false,
          ghostClass: "ghost"
        };
      }
    },
    mounted () {
      this.isExpand = []
      this.getPermission()
    },
    methods: {
      getPermission () {
        if (this.userID !== 'new') {
          api.getItem('users', true, utils.getUserID()).then(response => {
            this.isMoveContent = response.Permission.indexOf(3) >= 0
          })
        }
      },
      handleChangeSort () {
        for (let i = 0; i < this.contents.length; i++) {
          this.contents[i].ORD = i
        }
      },
      handleEndDragging () {
        this.dragging = false
        this.handleMoveDisabled(true)
      },
      handleMoveDisabled (value) {
        this.moveDisabled = value
      }
    }
  }
</script>

<style lang="scss" scoped>
  .button {
    margin-top: 35px;
  }
  .flip-list-move {
    transition: transform 0s;
  }
  .no-move {
    transition: transform 0s;
  }
  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }
  .list-group {
    min-height: 20px;
  }
  .list-group-item {
    /* cursor: move !important; */
  }
  .list-group-item i {
    cursor: pointer;
  }
  .list-group-item i {
    cursor: pointer;
  }
</style>

